import React, { useState } from 'react';
import { Box, Typography, Container } from '@material-ui/core';

const faqs = [
  {
    question: "How do I book my tickets online?",
    answer: "4 Simple Steps To Buy Tickets Online:\n• Click on MOVIES → NOW PLAYING and select your movie.\n• Select BOOK NOW, preferred class (Gold or Silver), date, time and seats.\n• Enter your payment details to complete booking.\n• Note your Transaction ID — required at the ticket counter. Tickets must be booked at least 2 hours before the show."
  },
  {
    question: "What are the charges for booking tickets online?",
    answer: "A nominal convenience fee per ticket is charged. You must collect your tickets from the booking counter before the show using your Transaction ID and the Credit Card used for booking."
  },
  {
    question: "Can we carry belongings inside the cinema?",
    answer: "Please do NOT carry cameras, laptops, electronic items, shopping bags, outside food, chewing gum, helmets, cigarettes or tobacco items inside the cinema premises."
  },
  {
    question: "Can I book tickets in advance?",
    answer: "YES! You can book tickets for movies starting the following week from Friday. Go to the MOVIES section and click on your preferred show timing to start booking."
  },
  {
    question: "What payment methods are accepted online?",
    answer: "We accept Internet Banking, all major Credit and Debit cards (Visa, MasterCard, AMEX), and UPI payments. The cardholder must be present when collecting tickets at the Box Office."
  },
  {
    question: "How do I collect my tickets after booking?",
    answer: "Collect your tickets from the Box Office or ticket kiosk at the cinema. Please bring the Credit/Debit card used for booking. The cardholder MUST be present for security reasons."
  },
  {
    question: "Can I cancel tickets and get a refund?",
    answer: "There will be NO refund on cancellations. Partial cancellation is not allowed — the complete transaction will be cancelled. Refunds if applicable will be processed within 7 working days."
  },
  {
    question: "Will my seat be held if I am running late?",
    answer: "Yes! Once your purchase is confirmed, your admission is held and will NOT be sold to another customer."
  },
  {
    question: "How can I contact Innovative Multiplex?",
    answer: "Please email us at innovativemultiplex.ifa@gmail.com for all queries and suggestions. We are happy to help!"
  }
];

function FAQItem({ question, answer, isOpen, onClick, index }) {
  return (
    <div
      onClick={onClick}
      style={{
        borderBottom: '1px solid #f0f0f0',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        background: isOpen ? '#fff9f9' : '#fff',
        borderLeft: isOpen ? '4px solid #cc0000' : '4px solid transparent',
        marginBottom: '2px',
      }}
    >
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '25px 20px',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{
            width: '28px',
            height: '28px',
            borderRadius: '50%',
            background: isOpen ? '#cc0000' : '#f5f5f5',
            color: isOpen ? 'white' : '#999',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '12px',
            fontWeight: 700,
            flexShrink: 0,
            transition: 'all 0.3s ease',
          }}>
            {index + 1}
          </div>
          <p style={{
            fontSize: '15px',
            fontWeight: isOpen ? 700 : 600,
            color: isOpen ? '#cc0000' : '#333',
            transition: 'color 0.2s ease',
            lineHeight: 1.4,
            margin: 0,
          }}>
            {question}
          </p>
        </div>
        <div style={{
          width: '32px',
          height: '32px',
          borderRadius: '50%',
          background: isOpen ? '#cc0000' : '#f5f5f5',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          marginLeft: '12px',
          transition: 'all 0.3s ease',
          transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)',
        }}>
          <span style={{
            fontSize: '22px',
            color: isOpen ? 'white' : '#666',
            lineHeight: 1,
            fontWeight: 300,
          }}>
            +
          </span>
        </div>
      </div>

      <div style={{
        maxHeight: isOpen ? '400px' : '0',
        overflow: 'hidden',
        transition: 'max-height 0.4s ease',
      }}>
        <div style={{ padding: '0 20px 20px 60px' }}>
          {answer.split('\n').map((line, i) => (
            <p key={i} style={{
              fontSize: '14px',
              color: '#555',
              lineHeight: 1.7,
              margin: '0 0 4px 0',
              paddingLeft: line.startsWith('•') ? '8px' : '0',
            }}>
              {line}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  const handleClick = index => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div style={{
      background: '#fafafa',
      padding: '60px 0',
      marginTop: '40px',
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '30px 20px',
      }}>

        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <p style={{
            fontSize: '13px',
            fontWeight: 700,
            color: '#cc0000',
            letterSpacing: '2px',
            textTransform: 'uppercase',
            marginBottom: '8px',
          }}>
            Got Questions?
          </p>
          <h2 style={{
            fontSize: '32px',
            fontWeight: 800,
            color: '#111',
            marginBottom: '12px',
            lineHeight: 1.2,
          }}>
            Innovative Multiplex FAQ's
          </h2>
          <div style={{
            width: '60px',
            height: '4px',
            background: '#cc0000',
            borderRadius: '2px',
            margin: '0 auto',
          }} />
          <p style={{
            fontSize: '15px',
            color: '#888',
            marginTop: '16px',
          }}>
            Everything you need to know about booking at Innovative Multiplex
          </p>
        </div>

        <div style={{
          background: 'white',
          borderRadius: '12px',
          boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
          overflow: 'hidden',
          border: '1px solid #f0f0f0',
        }}>
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              index={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === index}
              onClick={() => handleClick(index)}
            />
          ))}
        </div>

        <div style={{
          textAlign: 'center',
          marginTop: '32px',
          padding: '20px',
          background: 'white',
          borderRadius: '12px',
          border: '1px solid #f0f0f0',
        }}>
          <p style={{
            fontSize: '15px',
            color: '#555',
            margin: 0,
          }}>
            Still have questions? Email us at{' '}
            <a
              href="mailto:innovativemultiplex.ifa@gmail.com"
              style={{
                color: '#cc0000',
                fontWeight: 600,
                textDecoration: 'none',
              }}
            >
              innovativemultiplex.ifa@gmail.com
            </a>
          </p>
        </div>

      </div>
    </div>
  );
}